export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">
                  黑料在线
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                黑料在线 — 专业的黑料视频在线观看平台。提供海量黑料在线播放资源，
                每日更新最新黑料大瓜，满足广大吃瓜网友的需求。黑料在线视频免费观看，
                是您获取最新爆料资讯的首选平台。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-foreground-700 text-foreground-300 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-foreground-700 text-foreground-300 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-foreground-700 text-foreground-300 transition-colors cursor-pointer">
                  <i className="ri-telegram-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                <li><a href="#media" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">精彩视频</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">热度榜单</a></li>
                <li><a href="#updates" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">最新快讯</a></li>
                <li><a href="#features" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">平台特色</a></li>
                <li><a href="#faq" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-bold text-background-50 mb-4">热门话题</h3>
              <ul className="space-y-2.5">
                <li><a href="#topics" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">黑料在线观看</a></li>
                <li><a href="#topics" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">黑料在线播放</a></li>
                <li><a href="#topics" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">黑料在线视频</a></li>
                <li><a href="#topics" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">黑料在线免费观看</a></li>
                <li><a href="#topics" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">在线观看黑料</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-bold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                合作伙伴信息待更新，欢迎优质内容创作者与媒体平台洽谈合作。
              </p>
              <div className="mt-4">
                <a
                  href="#contact"
                  className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i>
                  商务合作联系
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; 2026 黑料在线. 本站内容仅供娱乐参考，不构成任何建议。
              </p>
              <div className="flex items-center gap-4">
                <a href="#hero" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">用户协议</a>
                <a href="#hero" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
                <a href="#hero" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}